import './dashboard.css';
import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import { Button, Grid, Grid2, Typography, Stack, Pagination, Avatar, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TablePagination } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import prevIcon from '../../assets/icons/left-arrow.svg'
import nextIcon from '../../assets/icons/right-arrow.svg';
import starIcon from '../../assets/icons/starIcon.png';
import { CSVLink } from "react-csv";
import axios from 'axios';
import TokenError from '../tokenError';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { Dialog, DialogTitle, DialogContent, TextField, Box} from '@mui/material';

const Dashboard = () => {

    const serverUrl = config.serverUrl;
    const navigate = useNavigate();
    const location = useLocation();

    const [rows, setRows] = useState([]);
    const [allData, setAllData] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [paginatedData, setPaginatedData] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [driverId, setDriverId] = useState('');
    const [driverPhone, setDriverPhone] = useState('');
    const [verificationStatus, setVerificationStatus] = useState("");

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);


    const [open, setOpen] = useState(false);
    const [amount, setAmount] = useState('');
    const [reason, setReason] = useState('');
    const [type, setType] = useState('credit');

    const handleOpen = (row) => {
      setSelectedRow(row);
      setType('credit'); // Reset to default when opening modal
      setAmount(''); // Clear amount
      setReason(''); // Clear reason
      setOpen(true);
    };
    const handleClose = () => setOpen(false);

    const handleInputChange = (e) => {
        setDriverId(e.target.value);
        setDriverPhone('');
    };
    
    const handlePhoneChange = (e) => {
        setDriverPhone(e.target.value);
        setDriverId('');
    };

    const handleVerificationChange = (value) => {
        setVerificationStatus(value);
    };    

    const fetchData = async () => {
        const query = new URLSearchParams(location.search);
        const driverIdParam = query.get('driver_id');
        if (driverIdParam && !driverId) {
            setDriverId(driverIdParam);
        }

        const driverPhoneParam = query.get('phone_number');
        let decodedPhoneParam;
        if (driverPhoneParam && !driverPhone) {
            decodedPhoneParam = driverPhoneParam.replace(/ /g, '+'); // Decodes + back to +
            setDriverPhone(decodedPhoneParam);
        }
    
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/driver/fetch_all`;
            const obj={
                token: token, timestamp: timestamp
            }

            const response =  await makeGetRequestToUrl(url, obj);

            console.log('response = ', response)

            // console.log("response", data)

            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag==200){
                setRows(response.data);
                setFilteredRows(response.data);
                
                const formattedData = formatDataForCSV(response.data);
                setAllData(formattedData);
                // Apply filter if driverId is set from URL or manually
                if (driverIdParam) {
                    setFilteredRows(response.data.filter((item) => item.driver_id === parseInt(driverIdParam, 10)));
                }
                if (decodedPhoneParam) {
                    setFilteredRows(response.data.filter((item) => item.phone_number === decodedPhoneParam));
                }
            }
            
        } catch (error) {
            console.error('Error fetching data:', error);
            setRows([]);
            setFilteredRows([]);
            navigate(location.pathname, { replace: true });
        }
    };

    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
    
    useEffect(() => {
        fetchData();
    }, []);

    // Apply filter when driverId changes
    useEffect(() => {
        if (driverId && rows&&  rows.length > 0) {
            // const filteredData = rows.filter((item) => item.driver_id === parseInt(driverId, 10));
            const filteredData = rows.filter((item) => 
                item.driver_id.toString().includes(driverId) || driverId === ''
            );
            setFilteredRows(filteredData);
            setPage(0); // Reset to the first page after filtering
            navigate(`?driver_id=${driverId}`, { replace: true });
        }
        else if(driverPhone && rows &&rows.length > 0){
            const filteredPhoneData = rows.filter((item) => 
                // item.phone_number == driverPhone
                item.phone_number.toString().includes(driverPhone) || driverPhone === ''
            );

            rows.forEach((item) => {
                console.log(typeof item.phone_number, item.phone_number);
            });

            setFilteredRows(filteredPhoneData);
            setPage(0); // Reset to the first page after filtering
            navigate(`?phone_number=${driverPhone}`, { replace: true });
        }
        else if (verificationStatus !== "" && rows && rows.length > 0) {
            // Ensure verificationStatus is cast to a number before comparing
            const filteredVerificationData = rows.filter((item) => item.driver_verification_status === Number(verificationStatus));
            setFilteredRows(filteredVerificationData);
            setPage(0);
        }
        else if (rows && rows.length > 0) {
            setFilteredRows(rows); // Reset to all rows if no driverId/driverPhone is provided
            navigate(location.pathname, { replace: true });
        }
    }, [driverId, driverPhone, verificationStatus]);



    // UseEffect for filtering based on driverId changes
    // useEffect(() => {
    //     if (rows.length > 0) { // Ensure rows are fetched before filtering
    //         getFilteredData();
    //     }
    // }, [driverId]);

    // const getFilteredData = () => {
    //     if(driverId){
    //         // setFlag(1);
    //         const filteredData = rows.filter((item) => item.driver_id === parseInt(driverId, 10));
    //         setFilteredRows(filteredData);
    //         setPage(0);
    //         navigate(`?driver_id=${driverId}`, { replace: true });
    //     }
    //     // if(docStatus==-1 || docStatus==0 || docStatus==1 || docStatus==2){
    //     //     setFlag(1);
    //     //     const filteredData = rows.filter((item) => item.driver_verification_status === parseInt(docStatus, 10));

    //     //     const paginated = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    
    //     //     setPaginatedData(paginated);
    //     // }
    //     else{
    //         setFilteredRows(rows);
    //         navigate(location.pathname, { replace: true });
    //     }
    // }

    // Paginate filtered data when `filteredRows`, `page`, or `rowsPerPage` changes
    useEffect(() => {
        const paginated = Array.isArray(filteredRows)
            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : [];
        setPaginatedData(paginated);
    }, [filteredRows, page, rowsPerPage]);

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...filteredRows].sort((a, b) => {
        if (a[property] < b[property]) return isAscending ? -1 : 1;
        if (a[property] > b[property]) return isAscending ? 1 : -1;
        return 0;
        });
        // setRows(sortedRows);
        setFilteredRows(sortedRows);
    };

    const viewData = (row) => {
        navigate('/driver-details', { state: { rowData: row } });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const formatDataForCSV = (data) => {
        return data ? (data.map((item) => ({
            ...item,
            driver_verification_status:
                item.driver_verification_status === -1
                    ? 'Not Uploaded'
                    : item.driver_verification_status === 0
                    ? 'Pending'
                    : item.driver_verification_status === 1
                    ? 'Approved'
                    : item.driver_verification_status === 2
                    ? 'Rejected'
                    : item.driver_verification_status, // Fallback in case of an unexpected value
            
            driver_current_status:
                item.driver_current_status === 0 ? 'Offline' : 'Online',

            registered_date : item.registered_date.split('T')[0],

            date_of_birth : item.date_of_birth.split('T')[0],

            city_id : (clientCities.find(city => city.city_id === item.city_id)) ? (clientCities.find(city => city.city_id === item.city_id)).city_name : '--',
            
            gender : item.gender==1 ? 'Male' : item.gender==2 ? 'Female' : item.gender==3 ? 'Others' : 'Others'
        }))) : '';
    };

    // Define custom headers
    const headers = [
        { label: 'Driver ID', key: 'driver_id' },
        { label: 'Driver Name', key: 'driver_name' },
        { label: 'Email', key: 'email' },
        { label: 'Phone Number', key: 'phone_number' },
        { label: 'Driver Doc Verification Status', key: 'driver_verification_status' },
        { label: 'Driver Image', key: 'driver_image' },
        { label: 'City', key: 'city_id' },
        { label: 'Gender', key: 'gender' },
        { label: 'Current Latitude', key: 'current_latitude' },
        { label: 'Current Longitude', key: 'current_longitude' },
        { label: 'Date Of Birth', key: 'date_of_birth' },
        { label: 'Total Trips', key: 'total_trips' },
        { label: 'Rating', key: 'rating' },
        { label: 'Driver Current Status', key: 'driver_current_status' },
        { label: 'Registered Date', key: 'registered_date'}
    ];

    const handleSubmit = async () => {
      if (!selectedRow) {
          console.log("No user selected for transaction");
          return;
      }
  
      try {
          const token = localStorage.getItem('token');
          // Map 'credit' to 1 and 'debit' to 2
          const txnType = type === "credit" ? 1 : 2;
  
          const params = {
              token,
              txn_type: txnType,
              amount,
              user_id: selectedRow.driver_id,
              user_type: 1, //driver constant
              reason
          };
  
          await axios.post(`${serverUrl}/admin/wallet_transactions`, params);
          await fetchData(); // Re-fetch updated data
          handleClose();
      } catch (error) {
          console.error('Error while submitting:', error.message);
      }
    };

    return (
      <div>
        {tokenExpired && <TokenError />}

        <Typography style={{ fontSize: "28px", fontWeight: "500" }}>
          User
        </Typography>
        <Typography style={{ color: "#83888E" }}>User / Driver</Typography>

        <Grid2
          container
          spacing={2}
          direction="row"
          alignItems="center"
          wrap="nowrap"
          style={{ marginTop: "2%", marginBottom: "2%" }}
        >
          <Grid2 xs="auto">
            <input
              type="number"
              placeholder="Driver Id"
              className="filterBtn"
              value={driverId}
              onChange={handleInputChange}
              min="0" 
              onKeyDown={(e) => {
                if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                  e.preventDefault();
                }
            }}
            />
          </Grid2>
          <Grid2 xs="auto">
            <input
              type="number"
              placeholder="Phone Number"
              className="filterBtn"
              value={driverPhone}
              onChange={handlePhoneChange}
            />
          </Grid2>
          {/* Verification Status Dropdown */}
          <Grid2 item>
            <Select
              value={verificationStatus}
              onChange={(e) => handleVerificationChange(e.target.value)}
              displayEmpty
              sx={{
                width: "200px",
                height: "45px",
                borderRadius: "8px",
                backgroundColor: verificationStatus ? "#F9F9F9" : "#FFFFFF",
                color: "#83888E",
                fontSize: "14px",
                fontWeight: "500",
                padding: "10px",
                "& .MuiSelect-select": {
                  paddingLeft: "10px",
                  paddingTop: "10px", // Padding for the selected option
                  paddingBottom: "10px", // Match the input padding
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#D1D5DB", // Light grey border
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#B0BEC5", // Slightly darker grey on hover
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1976D2", // Blue border when focused (default Material-UI blue)
                },
                "&.Mui-focused .MuiSelect-icon": {
                  color: "#1976D2", // Blue icon when focused
                },
              }}
            >
              <MenuItem value={""}>Verification Status</MenuItem>{" "}
              {/* Grey for placeholder */}
              <MenuItem value={-1}>Not Uploaded</MenuItem>
              <MenuItem value={0}>Pending</MenuItem>
              <MenuItem value={1}>Approved</MenuItem>
            </Select>
          </Grid2>

          {/* <Grid2 xs="auto">
                    <FormControl sx={{width:'auto', minWidth:'180px', backgroundColor:'#fff', minheight:'60px'}}>
                        <InputLabel id="demo-simple-select-label" >Doc Status</InputLabel>
                        <Select labelId="demo-simple-select-label" id="demo-simple-select"
                            value={docStatus} label="docStatus" onChange={handleDocStatusChange}>
                            <MenuItem value={-1}>Not Uploaded</MenuItem>
                            <MenuItem value={0}>Pending</MenuItem>
                            <MenuItem value={1}>Approved</MenuItem>
                            <MenuItem value={2}>Rejected</MenuItem>
                        </Select>
                    </FormControl>
                </Grid2> */}
          {/* <Grid2 xs="auto" style={{marginLeft:'4%'}}>
                    <Button variant="contained" onClick={getFilteredData} style={{width: '170px', height: '44px', marginRight: '12px', backgroundColor: '#0065FF', textTransform:'none', borderRadius:'8px'}}> Apply Filter</Button>
                </Grid2> */}
          <Grid2 xs="auto">
            <Button
              variant="contained"
              style={{
                width: "120px",
                height: "44px",
                backgroundColor: "#36C68F",
                textTransform: "none",
                borderRadius: "8px",
              }}
            >
              <CSVLink
                data={allData}
                headers={headers}
                filename={"Driver Data.csv"}
                style={{ textDecoration: "none" }} // Add this line to remove underline
              >
                <Typography sx={{ color: "#fff" }}>Export CSV</Typography>
              </CSVLink>
            </Button>
          </Grid2>
        </Grid2>

        <TableContainer className="table-container">
          <Table stickyHeader className="scrollable-table">
            <TableHead>
              <TableRow>
                <TableCell align="center" className="table-header">
                  <TableSortLabel
                    className="table-header"
                    active={orderBy === "driver_id"}
                    direction={orderBy === "driver_id" ? order : "asc"}
                    onClick={() => handleRequestSort("driver_id")}
                    sx={{
                      "& .MuiTableSortLabel-icon": {
                        color: "#0065FF !important", // Change the arrow color
                      },
                    }}
                  >
                    Driver ID
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    {" "}
                    Driver
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    {" "}
                    Email
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    {" "}
                    Gender
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    {" "}
                    Current Latitude
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    {" "}
                    Current Longitude
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel
                    className="table-header"
                    active={orderBy === "total_trips"}
                    direction={orderBy === "total_trips" ? order : "asc"}
                    onClick={() => handleRequestSort("total_trips")}
                    sx={{
                      "& .MuiTableSortLabel-icon": {
                        color: "#0065FF !important", // Change the arrow color
                      },
                    }}
                  >
                    Total Trips
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel
                    className="table-header"
                    active={orderBy === "rating"}
                    direction={orderBy === "rating" ? order : "asc"}
                    onClick={() => handleRequestSort("rating")}
                    sx={{
                      "& .MuiTableSortLabel-icon": {
                        color: "#0065FF !important", // Change the arrow color
                      },
                    }}
                  >
                    Rating
                  </TableSortLabel>
                </TableCell>

                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    Status
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    Document Verification Status
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    Driver Wallet Balance
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    Action
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "center",
                        width: "auto",
                        minWidth: "100px",
                        pr: "28px",
                      }}
                    >
                      {row.driver_id}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                      <Grid2>
                        <Avatar
                          sx={{ borderColor: "#0065FF", border: 1 }}
                          alt={row.driver_name}
                          src={row.driver_image}
                        ></Avatar>
                      </Grid2>
                      <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                        <Grid2>
                          <Typography>{row.driver_name}</Typography>
                        </Grid2>
                        <Grid2>
                          <Typography
                            sx={{ color: "#83888E", fontSize: "12px" }}
                          >
                            {row.phone_number}
                          </Typography>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ textAlign: "left" }}>
                      {row.email}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "left",
                        width: "auto",
                        minWidth: "120px",
                      }}
                    >
                      {row.gender == 1
                        ? "Male"
                        : row.gender == 2
                        ? "Female"
                        : row.gender == 3
                        ? "Others"
                        : "Others"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "left",
                        width: "auto",
                        minWidth: "100px",
                      }}
                    >
                      {row.current_latitude}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "left",
                        width: "auto",
                        minWidth: "100px",
                      }}
                    >
                      {row.current_longitude}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "center",
                        width: "auto",
                        minWidth: "100px",
                        marginRight: "12px",
                      }}
                    >
                      {row.total_trips}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    <img
                      src={starIcon}
                      height="12px"
                      width="12px"
                      style={{ marginRight: "1%" }}
                    />{" "}
                    {parseFloat(row.rating).toFixed(2)}
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor:
                          row.driver_current_status == 0
                            ? "#F9E9E9"
                            : "#E7F8F2",
                        color:
                          row.driver_current_status == 0
                            ? "#D14545"
                            : "#0DBA78",
                        textTransform: "none",
                        pointerEvents: "none",
                        borderRadius: "6px",
                        minWidth: "60px",
                        border: "none",
                        boxShadow: "none",
                        fontFamily: "Poppins",
                        marginRight: "16px",
                      }}
                    >
                      <FiberManualRecordIcon style={{ fontSize: "16px" }} />{" "}
                      {row.driver_current_status == 0 ? "Offline" : "Online"}
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor:
                          row.driver_verification_status == -1
                            ? "#F9F9F9"
                            : row.driver_verification_status == 0
                            ? "#F5BB19"
                            : row.driver_verification_status == 1
                            ? "#0DBA78"
                            : "#D14545",
                        color:
                          row.driver_verification_status == -1
                            ? "#000"
                            : "#FFFFFF",
                        textTransform: "none",
                        pointerEvents: "none",
                        borderRadius: "6px",
                        minWidth: "60px",
                        border: "none",
                        boxShadow: "none",
                        fontFamily: "Poppins",
                        width: "auto", // Or set a specific width
                        minWidth: "120px",
                      }}
                    >
                      {row.driver_verification_status == -1
                        ? "Not Uploaded"
                        : row.driver_verification_status == 0
                        ? "Pending"
                        : row.driver_verification_status == 1
                        ? "Approved"
                        : "Rejected"}
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "center",
                        width: "auto",
                        minWidth: "100px",
                        marginRight: "12px",
                      }}
                    >
                      {row.driver_wallet_balance}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      onClick={() => viewData(row)}
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        border: "1px solid black",
                        textTransform: "none",
                        borderRadius: "8px",
                        width: "auto", // Or set a specific width
                        minWidth: "120px",
                        marginBottom: "10px",
                        "&:hover": {
                          backgroundColor: "black",
                          color: "white",
                        },
                        "&:active": {
                          backgroundColor: "black",
                          color: "white",
                        },
                      }}
                    >
                      View Details
                    </Button>

                    <Button
                      variant="contained"
                      onClick={() => handleOpen(row)}
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        border: "1px solid black",
                        textTransform: "none",
                        borderRadius: "8px",
                        width: "auto", // Or set a specific width
                        minWidth: "120px",
                        "&:hover": {
                          backgroundColor: "black",
                          color: "white",
                        },
                        "&:active": {
                          backgroundColor: "black",
                          color: "white",
                        },
                      }}
                    >
                      Credit/Debit
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {filteredRows && (
            <div className="custom-pagination">
              <div className="pagination-info">
                {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                  (page + 1) * rowsPerPage,
                  filteredRows.length
                )} of ${filteredRows.length} entries`}
              </div>
              <div className="pagination-controls">
                <button
                  onClick={() => handleChangePage(null, page - 1)}
                  disabled={page === 0}
                  className="pagination-arrow"
                >
                  <img src={prevIcon} alt="Previous" />
                </button>
                <div className="pagination-numbers">
                  {/* {[...Array(Math.ceil(filteredRows.length / rowsPerPage))].map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${
                                        page === index ? 'active' : ''
                                    }`}
                                >
                                    {index + 1}
                                </button>
                            ))} */}
                  {page > 1 && (
                    <>
                      <button
                        onClick={() => handleChangePage(null, 0)}
                        className="pagination-number"
                      >
                        1
                      </button>
                      <span className="pagination-dots">...</span>
                    </>
                  )}
                  {[...Array(Math.ceil(filteredRows.length / rowsPerPage))]
                    .map((_, index) => index)
                    .filter((index) => index >= page - 1 && index <= page + 1) // Show only previous, current, and next page
                    .map((index) => (
                      <button
                        key={index}
                        onClick={() => handleChangePage(null, index)}
                        className={`pagination-number ${
                          page === index ? "active" : ""
                        }`}
                      >
                        {index + 1}
                      </button>
                    ))}

                  {page < Math.ceil(filteredRows.length / rowsPerPage) - 2 && (
                    <>
                      <span className="pagination-dots">...</span>
                      <button
                        onClick={() =>
                          handleChangePage(
                            null,
                            Math.ceil(filteredRows.length / rowsPerPage) - 1
                          )
                        }
                        className="pagination-number"
                      >
                        {Math.ceil(filteredRows.length / rowsPerPage)}
                      </button>
                    </>
                  )}
                </div>
                <button
                  onClick={() => handleChangePage(null, page + 1)}
                  disabled={
                    page >= Math.ceil(filteredRows.length / rowsPerPage) - 1
                  }
                  className="pagination-arrow"
                >
                  <img src={nextIcon} alt="Next" />
                </button>
              </div>
            </div>
          )}
        </TableContainer>

        {/* Dialog */}
        <Dialog
                open={open}
                onClose={handleClose}
                sx={{
                    '& .MuiDialog-paper': {
                        width: '50%',
                        maxWidth: 'none',
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                    }}
                >
                    User Wallet Transactions
                </DialogTitle>
                <DialogContent>
                    <Box display="flex" alignItems="center" mb={2}>
                        <Box width="30%" fontWeight="bold">
                            Type:
                        </Box>
                        <FormControl fullWidth>
                            <Select
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Type' }}
                            >
                                <MenuItem value="credit">Credit</MenuItem>
                                <MenuItem value="debit">Debit</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <Box display="flex" alignItems="center" mb={2}>
                        <Box width="30%" fontWeight="bold">
                            Amount:
                        </Box>
                        <TextField
                            fullWidth
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter Amount"
                        />
                    </Box>

                    <Box display="flex" alignItems="center" mb={2}>
                        <Box width="30%" fontWeight="bold">
                            Reason:
                        </Box>
                        <TextField
                            fullWidth
                            type="string"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="Enter Reason"
                        />
                    </Box>
                </DialogContent>

                <Box display="flex" justifyContent="center" gap={2} mt={3} mb={2}>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        color="primary"
                        sx={{ width: '150px' }}
                        disabled={!amount || !reason} // Disable if amount or reason is empty
                    >
                        {type === 'credit' ? 'Credit' : 'Debit'}
                    </Button>
                    <Button onClick={handleClose} color="secondary" variant="outlined">
                        Cancel
                    </Button>
                </Box>
            </Dialog>
      </div>
    );
};

export default Dashboard;